import * as React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import asyncAction from 'modules/core/lib/asyncAction'
import { apiClient } from 'modules/core/lib/mobx-rest'

import { usePerformanceModuleContext } from 'modules/performance/hooks/usePerfomanceModuleContext'
import { useReview } from 'modules/reviews/hooks/useReview'
import { canEditReview } from 'modules/reviews/lib/canEditReview'

import { ReviewShowContext } from './hooks'

const ReviewShowPage = () => {
  const { id } = useParams()
  const { loading, review } = useReview(id)
  const { hasFullVisibility } = usePerformanceModuleContext()

  const [canbeStarted, setCanBeStarted] = React.useState(false)

  const fetchCanBeStarted = async () => {
    const api = apiClient()
    const result = await api.get(`/performance_reviews/reviews/${id}/status`)
    setCanBeStarted(result.can_be_started)
  }

  const updateCanBeStarted = async () =>
    await asyncAction(fetchCanBeStarted, {
      errorFlash: false,
      successFlash: false,
    })

  if (loading) return <Loading />

  if (!review) return <NotFound />

  const canEdit = canEditReview(review, hasFullVisibility)

  const values = {
    review: review,
    canbeStarted: canbeStarted,
    updateCanBeStarted: updateCanBeStarted,
    canEditReview: canEdit,
    isAnonymous: !!review && review.isAnonymous,
  }

  return (
    <ReviewShowContext.Provider value={values}>
      <Outlet context={{ review }} />
    </ReviewShowContext.Provider>
  )
}

export default ReviewShowPage
